import { QueryFunction } from "react-query";
import { ErrorResponse } from "./useBackendMutationFunction";
import { UrlQuery, useBackendUrl } from "./useBackendUrl";

export function useBackendQueryFunction<T>(
  path: string,
  params: UrlQuery = {}
) {
  const url = useBackendUrl(path, params);

  const queryFn: QueryFunction<T> = async ({ signal }) => {
    const init = {
      signal,
      method: "GET",
    };
    const response = await fetch(url, {
      ...init,
    });
    if (!response.ok) {
      const error: ErrorResponse = (await response.json()) as ErrorResponse;
      throw new Error(error.error);
    }
    return (await response.json()) as T;
  };

  return queryFn;
}
